import { Controller, FieldValues, RegisterOptions } from "react-hook-form";

interface Props {
  label?: string;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
  control?: any;
  name?: string;
  rules?:
    | Omit<
        RegisterOptions<FieldValues, string>,
        "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
      >
    | undefined;
}

export const ControlledTextarea = ({
  label,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  control,
  name,
  rules,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <Controller
        control={control}
        name={name as string}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <textarea
            {...rest}
            value={value}
            onChange={onChange}
            className={`w-full min-h-32 px-4 py-[11px] bg-sky-lighter border ${
              error ? "border-red-base" : "border-gray-border"
            } ${
              error ? "focus:border-red-base" : "focus:border-focused-border"
            } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
            placeholder={placeholder}
          />
        )}
      />
    </div>
  );
};
